export enum ActionBarType {
  NEW,
  SAVE,
  SAVE_CLOSE,
  DELETE,
  REFRESH,
  UPLOAD,
  CLOSE,
  DOWNLOAD,
  ADD,
  REPORT,
  CLOSING_METER_DATA
}
